import Vue from 'vue';
import * as FullStory from '@fullstory/browser';
import {Environment} from '@simpleinvest/environment-utils';

export interface InitOptions {
  env: Environment;
  fullstoryOrg?: string;
  release: string;
  tracingOrigins?: string[];
}

/**
 * Initializes front-end-logger-js
 *
 * @param options A {@link InitOptions} object.
 * @since 1.0.0
 */
// eslint-disable-next-line max-lines-per-function
export const init = (options: InitOptions): void => {
  const fullstoryOrg = options?.fullstoryOrg || 'BX2V6';

  FullStory.init({orgId: fullstoryOrg});
  Vue.prototype.$FullStory = FullStory;

  // eslint-disable-next-line max-lines-per-function, prefer-arrow-callback
  window.addEventListener('error', function (event) {
    const chunkFailedMessage = /Loading chunk .* failed/;

    if (chunkFailedMessage.test(event?.message)) {
      // eslint-disable-next-line no-console
      console.log(JSON.stringify(event));
      window.location.reload();
    } else {
      // eslint-disable-next-line no-console
      console.error(
        `An error occurred. Message: ${event?.message} File name: ${event?.filename} Line: ${event?.lineno} Column: ${event?.colno}`,
        event?.error
      );
    }
  });
};
